module.exports = __webpack_public_path__ + "assets/benefits-card-7d571b.svg";